// removed by extract-text-webpack-plugin
module.exports = {"import-section":"import-section","import-text":"import-text","import-file":"import-file","import-chose":"import-chose","import-downloadmodel":"import-downloadmodel","import-submit":"import-submit","import-upload-info":"import-upload-info","success":"success","fail":"fail","import-failload":"import-failload","info":"info"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Action/Import.scss
// module id = 268
// module chunks = 0